import React from 'react';
import { View, TouchableOpacity, StyleSheet, Linking, Platform, Image } from 'react-native';
import { LinearGradient } from 'expo-linear-gradient';
import { Feather } from '@expo/vector-icons';
import { connect } from 'react-redux';

import getPlatformType from '../../helpers/helpers';
import { navigate } from '../../navigation/RootNavigation';

const layoutType = getPlatformType();

class FooterLanding extends React.Component {
  getLegalBitsUrl = (tab) => {
    const origin = Platform.OS === 'web' && typeof window !== 'undefined' ? window.location.origin : '';
    return `${origin}/legal-bits?tab=${tab}`;
  };

  openExternal = (value, type = 'url') => {
    const target = type === 'email' ? `mailto:${value}` : type === 'phone' ? `tel:${value}` : value;

    Linking.canOpenURL(target).then((supported) => {
      if (!supported) return;
      if (Platform.OS === 'web' && type === 'url') {
        window.open(target);
        return;
      }
      Linking.openURL(target);
    });
  };

  render() {
    const isPhone = layoutType === 'phone';
    const isWeb = layoutType === 'web';
    const { userToken } = this.props;

    return (
      <View style={[styles.wrapper, isPhone && styles.wrapperMobile, isWeb && styles.wrapperWeb]}>
        <View style={[styles.logoWrap, isPhone && styles.logoWrapMobile]}>
          <TouchableOpacity onPress={() => navigate(userToken?"home": 'Hello')} activeOpacity={0.9}>
            <Image
              source={require('../../assets/images/Logo/HubitaWeb.png')}
              style={[styles.logo, isPhone && styles.logoMobile, isWeb && styles.logoWeb]}
              resizeMode="contain"
            />
          </TouchableOpacity>
        </View>

        <View style={[styles.contactWrap, isPhone && styles.contactWrapMobile, isWeb && styles.contactWrapWeb]}>
          <View style={styles.contactTitleRow}>
            <View style={styles.contactAccent} />
            <View>
              <TouchableOpacity activeOpacity={0.9} onPress={() => navigate('ContactUs')}>
                <View>
                  <LabelText style={[styles.contactHeading, isWeb && styles.contactHeadingWeb]}>Contact Us</LabelText>
                </View>
              </TouchableOpacity>
            </View>
          </View>

          <View style={[styles.contactInfoRow, isPhone && styles.contactInfoRowMobile]}>


            <TouchableOpacity
              style={[styles.contactInfoItem, isWeb && styles.contactInfoItemWeb]}
              activeOpacity={0.85}
              onPress={() => this.openExternal('info@hubita.co.uk', 'email')}
            >
              <Feather name="mail" size={17} color="#CC58E3" style={styles.contactIconGraphic} />
              <LabelText style={[styles.contactText, isWeb && styles.contactTextWeb]}>info@hubita.co.uk</LabelText>
            </TouchableOpacity>
          </View>

          <View style={[styles.legalLinksRow, isPhone && styles.legalLinksRowMobile]}>
            <TouchableOpacity activeOpacity={0.85} onPress={() => this.openExternal(this.getLegalBitsUrl('terms'))}>
              <LabelText style={[styles.legalLinkText, isWeb && styles.legalLinkTextWeb]}>Terms</LabelText>
            </TouchableOpacity>
            <TouchableOpacity activeOpacity={0.85} onPress={() => this.openExternal(this.getLegalBitsUrl('privacy'))}>
              <LabelText style={[styles.legalLinkText, isWeb && styles.legalLinkTextWeb]}>Privacy Policy</LabelText>
            </TouchableOpacity>
            <TouchableOpacity activeOpacity={0.85} onPress={() => this.openExternal(this.getLegalBitsUrl('cookies'))}>
              <LabelText style={[styles.legalLinkText, isWeb && styles.legalLinkTextWeb]}>Cookies</LabelText>
            </TouchableOpacity>
          </View>
        </View>

        <View style={[styles.buttonGroup, isPhone && styles.buttonGroupMobile, isWeb && styles.buttonGroupWeb]}>
          {!userToken ? (
            <LinearGradient
              colors={['#CC58E3', '#B847DC']}
              start={{ x: 0, y: 0 }}
              end={{ x: 1, y: 0 }}
              style={[styles.buttonGradient, isPhone && styles.buttonGradientMobile, isWeb && styles.buttonGradientWeb]}
            >
              <TouchableOpacity
                style={[styles.buttonTouch, isPhone && styles.buttonTouchMobile, isWeb && styles.buttonTouchWeb]}
                onPress={() => navigate('RegisterScreen')}
                activeOpacity={0.9}
              >
                <LabelText style={[styles.buttonText, isPhone && styles.buttonTextMobile, isWeb && styles.buttonTextWeb]}>Get Started</LabelText>
              </TouchableOpacity>
            </LinearGradient>
          ) : null}

          <LinearGradient
            colors={['#2AA7FF', '#1C92EE']}
            start={{ x: 0, y: 0 }}
            end={{ x: 1, y: 0 }}
            style={[
              styles.buttonGradient,
              !isPhone && !userToken && styles.buttonSpacing,
              isPhone && styles.buttonGradientMobile,
              isWeb && styles.buttonGradientWeb,
            ]}
          >
            <TouchableOpacity
              style={[styles.buttonTouch, isPhone && styles.buttonTouchMobile, isWeb && styles.buttonTouchWeb]}
              onPress={() => navigate('ContactUs')}
              activeOpacity={0.9}
            >
              <LabelText style={[styles.buttonText, isPhone && styles.buttonTextMobile, isWeb && styles.buttonTextWeb]}>Contact Us</LabelText>
            </TouchableOpacity>
          </LinearGradient>
        </View>
      </View>
    );
  }
}

const LabelText = ({ style, children }) => <ViewText style={style}>{children}</ViewText>;

const ViewText = ({ style, children }) => {
  const { Text } = require('react-native');
  return <Text style={style}>{children}</Text>;
};

const styles = StyleSheet.create({
  wrapper: {
    width: '100%',
    backgroundColor: '#1B2A4E',
    paddingHorizontal: 34,
    paddingVertical: 22,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  wrapperWeb: {
    paddingHorizontal: 24,
    paddingVertical: 12,
    minHeight: 92,
  },
  wrapperMobile: {
    paddingHorizontal: 20,
    paddingVertical: 18,
    flexDirection: 'column',
    alignItems: 'stretch',
  },
  logoWrap: {
    flex: 0.95,
    justifyContent: 'center',
  },
  logoWrapMobile: {
    width: '100%',
    marginBottom: 10,
    alignItems: 'center',
  },
  logo: {
    width: 220,
    height: 66,
  },
  logoWeb: {
    width: 150,
    height: 46,
  },
  logoMobile: {
    width: 130,
    height: 42,
  },
  contactWrap: {
    flex: 1.2,
    justifyContent: 'center',
  },
  contactWrapWeb: {
    flex: 1.6,
    paddingHorizontal: 16,
  },
  contactWrapMobile: {
    width: '100%',
    marginBottom: 14,
  },
  contactTitleRow: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  contactAccent: {
    width: 4,
    height: 28,
    borderRadius: 999,
    backgroundColor: '#CC58E3',
    marginRight: 12,
  },
  contactHeading: {
    color: '#FFFFFF',
    fontSize: 20,
    lineHeight: 24,
    fontFamily: 'poppins',
    fontWeight: '700',
  },
  contactHeadingWeb: {
    fontSize: 16,
    lineHeight: 20,
  },
  contactInfoRow: {
    flexDirection: 'row',
    alignItems: 'center',
    flexWrap: 'wrap',
    marginTop: 12,
  },
  contactInfoRowMobile: {
    flexDirection: 'column',
    alignItems: 'flex-start',
    marginTop: 8,
  },
  contactInfoItem: {
    flexDirection: 'row',
    alignItems: 'center',
    marginRight: 22,
    marginTop: 6,
  },
  contactInfoItemWeb: {
    marginTop: 2,
  },
  contactIconGraphic: {
    marginRight: 10,
  },
  contactText: {
    color: '#FFFFFF',
    fontSize: 16,
    lineHeight: 22,
    fontFamily: 'roboto-light',
  },
  contactTextWeb: {
    fontSize: 14,
    lineHeight: 18,
  },
  legalLinksRow: {
    flexDirection: 'row',
    alignItems: 'center',
    flexWrap: 'wrap',
    marginTop: 12,
  },
  legalLinksRowMobile: {
    marginTop: 10,
  },
  legalLinkText: {
    color: '#FFFFFF',
    fontSize: 14,
    lineHeight: 20,
    fontFamily: 'poppins-medium',
    marginRight: 18,
    textDecorationLine: 'underline',
  },
  legalLinkTextWeb: {
    fontSize: 13,
    lineHeight: 18,
    marginRight: 14,
  },
  buttonGroup: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-end',
  },
  buttonGroupWeb: {
    alignSelf: 'center',
  },
  buttonGroupMobile: {
    width: '100%',
    flexDirection: 'column',
    alignItems: 'stretch',
  },
  buttonGradient: {
    borderRadius: 16,
    overflow: 'hidden',
  },
  buttonGradientWeb: {
    borderRadius: 12,
  },
  buttonGradientMobile: {
    width: '100%',
    marginTop: 10,
  },
  buttonSpacing: {
    marginLeft: 12,
  },
  buttonTouch: {
    minWidth: 132,
    height: 48,
    paddingHorizontal: 22,
    alignItems: 'center',
    justifyContent: 'center',
  },
  buttonTouchWeb: {
    minWidth: 110,
    height: 38,
    paddingHorizontal: 16,
  },
  buttonTouchMobile: {
    width: '100%',
    height: 44,
  },
  buttonText: {
    color: '#FFFFFF',
    fontSize: 16,
    lineHeight: 20,
    fontFamily: 'poppins-medium',
    fontWeight: '600',
  },
  buttonTextWeb: {
    fontSize: 14,
    lineHeight: 18,
  },
  buttonTextMobile: {
    fontSize: 15,
    lineHeight: 18,
  },
});

const mapStateToProps = (state) => ({
  userToken: state?.AppReducer?.token,
});

export default connect(mapStateToProps)(FooterLanding);
